export const IndexedAnnuity = {
    waivers_properties: [
        {
            'key': 'maxAgeAtIssue',
            'name': 'Maximum Age at Issue (years)',
        },
        {
            'key': 'minAgeToElect',
            'name': 'Minimum Age to Elect (years)',
        },
        {
            'key': 'maxWithAmount',
            'name': 'Maximum Withdrawal Amount ($)',
        },
        {
            'key': 'contractInForce',
            'name': 'Contract Must be in Force',
        },
        {
            'key': 'appliesTo',
            'name': 'Applies to',
        },
        {
            'key': 'whatWaived',
            'name': 'What Waived',
        },
        {
            'key': 'maxAgeToElect',
            'name': 'Maximum Age to Elect (years)',
        },
        {
            'key': 'waivedUpto',
            'name': 'Waived up to (%)',
        },
        {
            'key': 'waivedUptoValue',
            'name': 'Waived up to value ($)',
        },
        {
            'key': '',
            'name': 'Cannot Perform Two or More of The Six Defined Activities of Daily Living',
        },
        {
            'key': '',
            'name': 'Can Confinement Length Must Be Consecutive ?',
        },
        {
            'key': '',
            'name': 'State Exceptions',
        },
    ],
    withdrawal_options: [
        {
            key: '',
            name: 'Annual Free Currency',
        },
        {
            key: '',
            name: 'Annual Free Withdrawal',
            value: ''
        },
        {
            key: '',
            name: 'Cummulative',
            value: ''
        },
        {
            key: '',
            name: 'Delay(days)',
            value: ''
        },
        {
            key: '',
            name: 'Interest Only',
            value: ''
        },
        {
            key: '',
            name: 'Minimum Balance After Withdrawal',
            value: ''
        },
        {
            key: '',
            name: 'Minimum Free Withdrawal',
            value: ''
        },
        {
            key: '',
            name: 'Number of Annual Free Withdrawals',
            value: ''
        },
        {
            key: '',
            name: 'Loan',
        },
        {
            key: '',
            name: 'Auto Termination',
        },
        // {
        //     key: '',
        //     name: 'Systematic Withdrawals',
        // }
    ],
    systematic_withdwal_options: [
        {
            key: '',
            name: 'Minimum Systematic Withdrawal',
        },
        {
            key: '',
            name: 'Monthly',
        },
        {
            key: '',
            name: 'Quaterly',
        },
        {
            key: '',
            name: 'Semi-Annual',
        },
        {
            key: '',
            name: 'Annual',
        },
        {
            key: '',
            name: 'Systematic Qualified',
        },
    ],
    settlement_options: [
        {
            key: 'guarrt',
            name: 'Minimum Guaranteed Rate',
            type: '%'
        },
        {
            key: 'mrtyear',
            name: 'Mortality Table Year',
            type: 'number'
        },
        {
            key: 'minbal',
            name: 'Minimum Balance to Elect',
            type: 'currency'
        },
        {
            key: 'minpay',
            name: 'Minimum Modal Payment',
            type: 'currency'
        },
        {
            key: 'specamt',
            name: 'Specific Amount',
            type: 'boolean'
        },
        {
            key: 'mutagr',
            name: 'Mutual Agreement',
            type: 'boolean'
        },
        {
            key: 'qumindst',
            name: 'Qual. Min. Dist.',
            type: 'boolean'
        },
        {
            key: 'intcap',
            name: 'Interest Towards Capital',
            type: 'boolean'
        },
        {
            key: 'fxdtrm',
            name: 'Fixed Term Pay',
            type: 'boolean'
        },
        {
            key: 'altinc',
            name: 'Alternate Income',
            type: 'boolean'
        },
    ],
    settlement_table_options: [
        {
            key: 'yrtc',
            name: 'Year Certain'
        },
        {
            key: 'm60l',
            name: 'Male'
        },
        {
            key: 'f60l',
            name: 'Female'
        },
        {
            key: 'u60l',
            name: 'Single Unisex'
        },
        {
            key: 'mf60l',
            name: 'Male/Female'
        },
        {
            key: 'ju60l',
            name: 'Joint Unisex'
        },
        {
            key: 'jfanlhalf',
            name: 'JFANLHALF'
        },
        {
            key: 'jmanlhalf',
            name: 'JMANLHALF'
        }
    ]
}

export enum IndexProductTabsId {
    BasicInfo = 0,
    Interests = 1,
    Surrenders = 2,
    Withdrawals = 3,
    DeathBenefit = 4,
    Bonus = 5,
    GMAB = 6,
    GMIB = 7,
    GMWB = 8,
    Feature = 9
}